import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowRight = () => {
  return (
    <g>
      <path d="m10.455 2.147.084.073 5.241 5.248c.267.266.29.683.073.977l-.073.084-5.244 5.251a.749.749 0 0 1-1.133-.977l.073-.084 3.962-3.971H.75a.75.75 0 0 1-.102-1.493l.102-.007h12.69L9.48 3.28a.751.751 0 0 1-.073-.977l.072-.084a.749.749 0 0 1 .976-.073z" />
    </g>
  );
};

export default withIcon(IconArrowRight);
